import { Story } from "../../types/Story";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { storiesBaseUrl } from "../../config/urls";
import { useStoryById } from "../../hooks/CmsHooks";
import ScrollGallery from "../Gallery/ScrollGallery";
import ProductLink from "../ProductLink";
import { unwrapAsset } from "../../utils/CockpitUtils";
import { Link } from "react-router-dom";
import { Asset } from "../../types/Asset";
import "./style.scss";

const CaseDetails = ({ story }: { story?: Story }) => {
  const t = useBjelinTranslations();

  if (!story?.path) return null;

  const images =
    story.images?.map(item => unwrapAsset(item.value) as Asset) || [];

  return images.length > 0 ? (
    <div className="case-preview-large">
      {images && (
        <ScrollGallery images={images}>
          <></>
        </ScrollGallery>
      )}
      <div className="case-details">
        <div className="case-details-col1">
          <h1>{story.title}</h1>
          {story.description && (
            <p>
              <span>{story.description}</span>{" "}
              <strong>
                <Link to={storiesBaseUrl + "/" + story.path}>
                  {t("read.more")}
                </Link>
              </strong>
            </p>
          )}
        </div>
        <div className="case-details-col2">
          <ul>
            {story.category && (
              <li>
                <strong>{t("story.category")}:</strong>{" "}
                {t("story.category." + story.category)}
              </li>
            )}
            {story.location && (
              <li>
                <strong>{t("story.location")}:</strong> {story.location}
              </li>
            )}
            {story.year && (
              <li>
                <strong>{t("story.year")}:</strong> {story.year}
              </li>
            )}

            {story.architect && (
              <li>
                <strong>{t("story.architect")}:</strong>{" "}
                {story.architect_link ? (
                  <a
                    href={story.architect_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {story.architect}
                  </a>
                ) : (
                  <span>{story.architect}</span>
                )}
              </li>
            )}
            {story.builder && (
              <li>
                <strong>{t("story.builder")}:</strong>{" "}
                {story.builder_link ? (
                  <a href={story.builder_link} target="_blank" rel="noreferrer">
                    {story.builder}
                  </a>
                ) : (
                  <span>{story.builder}</span>
                )}
              </li>
            )}
            {story.photographer && (
              <li>
                <strong>{t("story.photographer")}:</strong>{" "}
                <a href="#">{story.photographer}</a>
              </li>
            )}
            {story.products?.length > 0 && (
              <li>
                <strong>{t("story.products")}:</strong>
                {story.products?.slice(0, 2).map((p, i) => (
                  <span key={i}>
                    {" "}
                    <ProductLink key={i} id={p._id} />
                  </span>
                ))}
                {story.products?.length > 2 && (
                  <span> + {story.products?.length - 2}</span>
                )}
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  ) : (
    <div>This story has no images.</div>
  );
};

const StoryPreviewLarge = ({ story: _story }: { story: { _id: string } }) => {
  const story = useStoryById(_story._id);
  return story && story._id ? <CaseDetails story={story} /> : null;
};

export default StoryPreviewLarge;
